export const emailValidationRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isEmail = (email: string): boolean =>
  emailValidationRegex.test(email);

export const numberValidationRegex = /^\d+$/;

// Expression will ensure that only values from 1 to 8, including .5 increments, are allowed.
export const addActivityValidationRegex = /^(?:0\.5|[1-7](?:\.5)?|8)$/;

export const isNumber = (number: string): boolean =>
  numberValidationRegex.test(number);
